import React, { useMemo } from 'react';
import { Tree, Spin } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { useQuery } from '@apollo/client';
import {
    GET_SCAN_SETTING_WAREHOUSE_TREE,
    GetScanSettingWarehouseTreeResponse,
    ScanSettingWarehouseNode,
} from '../graphql/pdaScanConfigQueries';

interface Props {
    selectedWarehouseId?: number;
    onSelect: (warehouseId: number) => void;
}

const toDataNode = (node: ScanSettingWarehouseNode): DataNode => ({
    key: String(node.warehouseId),
    title: node.name,
    children: (node.children ?? []).map(toDataNode),
});

const ScanSettingWarehouseTree: React.FC<Props> = ({ selectedWarehouseId, onSelect }) => {
    const { data, loading } = useQuery<GetScanSettingWarehouseTreeResponse>(GET_SCAN_SETTING_WAREHOUSE_TREE, {
        fetchPolicy: 'network-only',
    });

    const treeData = useMemo(
        () => (data?.getScanSettingWarehouseTree ?? []).map(toDataNode),
        [data],
    );

    if (loading) return <Spin />;

    return (
        <Tree
            treeData={treeData}
            defaultExpandAll
            selectedKeys={selectedWarehouseId ? [String(selectedWarehouseId)] : []}
            onSelect={(keys) => {
                const key = keys[0];
                if (key !== undefined) onSelect(Number(key));
            }}
        />
    );
};

export default ScanSettingWarehouseTree;
